<script>
import ClickConfirm from 'click-confirm';

export default {
  components: {
    ClickConfirm,
  },
}
</script>

<template>
  <click-confirm
    :messages="{title: 'Are you sure?', yes: 'Yes', no: 'No'}"
    yes-class="btn btn-success"
    no-class="btn btn-danger"
    yes-icon="fa fa-thumbs-up"
    no-icon="fa fa-thumbs-down">

    <slot
      v-bind="$attrs"
      v-on="$listeners"></slot>

  </click-confirm>
</template>



// WEBPACK FOOTER //
// src/VueConfirmClick.vue